import { useContext, useMemo } from "react";
import { Button } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import FormNumberInput from "go-form/components/FormNumberInput";
import { useCustomErrors } from "go-form/hooks";
import { CustomValidationConfig, CustomValidationConstraint } from "go-form/services/types";
import { apiPublic } from "../../../../../../../services/Api/Public/apiPublic";
import { OrderContext } from "../../../contexts/OrderContext";
import { EOrderTipForm } from "../../../services/types";
import { OrderTipSummary } from "./OrderTipSummary";

export const OrderTipFormInputs = ({ form }: { form: UseFormReturn<EOrderTipForm> }) => {
	const { t } = useTranslation();
	const { orderId, leftTipValue, currency } = useContext(OrderContext);
	const {
		control,
		formState: { errors },
		setError,
		handleSubmit,
		watch,
	} = form;
	const { setErrors, validateCustomErrors } = useCustomErrors(setError);
	const { addFlash } = useFlash();
	const displayCustomAmountInput = watch("tip") === null;

	const customAmountInputValidationConfig = useMemo(
		() => ({
			types: [{ constraint: CustomValidationConstraint.REQUIRED_IF, isRequired: () => displayCustomAmountInput }],
			setErrors,
		}),
		[setErrors, displayCustomAmountInput]
	) satisfies CustomValidationConfig;

	const leaveATipHandler = handleSubmit(async (data) => {
		if (!validateCustomErrors() || !orderId) {
			return;
		}

		try {
			const { tip: tipFromList, custom_amount } = data;
			const tipAmount = tipFromList ?? (custom_amount || 0);

			leftTipValue.current = tipAmount;

			const requestData = {
				tip: {
					amount: tipAmount,
				},
				public_order_id: orderId,
			};

			const { redirect_url: redirectURL } = await apiPublic.leaveATip(requestData);

			window.location.href = redirectURL;
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	});

	return (
		<div className="w-100">
			{displayCustomAmountInput && (
				<FormNumberInput
					name="custom_amount"
					control={control}
					errors={errors}
					suffix=""
					placeholder={`${t("common.word.amount")} (${currency})`}
					customValidationConfig={customAmountInputValidationConfig}
					firstInput
				/>
			)}
			{/* <FormInput
				name="email"
				register={register}
				errors={errors}
				placeholder="Email"
				className="order-tips-email-input"
			/> */}
			<OrderTipSummary watch={watch} />
			<Button onClick={leaveATipHandler}>{t("modules.e_order.action.leave_a_tip.title")}</Button>
		</div>
	);
};
